module.exports = __webpack_public_path__ + "static/media/SunriseLogo.85cdfb12.png";